import { render, staticRenderFns } from "./_base-lang-selector.vue?vue&type=template&id=5f89e83e&scoped=true"
import script from "./_base-lang-selector.vue?vue&type=script&lang=js"
export * from "./_base-lang-selector.vue?vue&type=script&lang=js"
import style0 from "./_base-lang-selector.vue?vue&type=style&index=0&id=5f89e83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89e83e",
  null
  
)

export default component.exports